import axios from '../api/index.js';

//查询友情链接列表
export let getLinksList = (params) => {
    return axios.post(`/client/links/list`, params);
};




// WEBPACK FOOTER //
// ./src/api/link.js